import { Tag } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import globalMessages from 'translations/messages';

const SurveyTypeTag = ({ type }) => (type && globalMessages[type.toLowerCase()] ? (
  <Tag key="type"><FormattedMessage {...globalMessages[type.toLowerCase()]} /></Tag>
) : null);

export default SurveyTypeTag;
